// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-datatable {
  border: 1px solid var(--primary-border-color);
  border-radius: 6px;
}

.p-datatable-wrapper {
  border-radius: 6px;
}

table {
  border-collapse: collapse;
}

.p-datatable-thead {
  background-color: var(--primary-background-color);
  font-size: 12px;
  font-weight: 800;
  color: var(--secondary-accent-text-color);
  border-radius: 6px 6px 0 0;
}

th {
  padding: 8px 4px;
}

thead {
  th:first-child {
    padding-left: 32px;
  }

  th:last-child {
    padding-right: 32px;
  }
}

tbody {
  td {
    padding: 8px 4px;
  }

  td:first-child {
    padding-left: 32px;
  }

  tr {
    height: 60px;
  }

  tr:not(:last-child) {
    border-bottom: 1px solid var(--secondary-border-color);
  }

  td:last-child {
    padding-right: 32px;
  }
}

@media (max-width: 768px) {
  thead {
    th:first-child {
      padding-left: 16px;
    }

    th:last-child {
      padding-right: 16px;
    }
  }

  tbody {
    td:first-child {
      padding-left: 16px;
    }

    td:last-child {
      padding-right: 16px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/table.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;EACF;AACF","sourcesContent":[".p-datatable {\n  border: 1px solid var(--primary-border-color);\n  border-radius: 6px;\n}\n\n.p-datatable-wrapper {\n  border-radius: 6px;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\n.p-datatable-thead {\n  background-color: var(--primary-background-color);\n  font-size: 12px;\n  font-weight: 800;\n  color: var(--secondary-accent-text-color);\n  border-radius: 6px 6px 0 0;\n}\n\nth {\n  padding: 8px 4px;\n}\n\nthead {\n  th:first-child {\n    padding-left: 32px;\n  }\n\n  th:last-child {\n    padding-right: 32px;\n  }\n}\n\ntbody {\n  td {\n    padding: 8px 4px;\n  }\n\n  td:first-child {\n    padding-left: 32px;\n  }\n\n  tr {\n    height: 60px;\n  }\n\n  tr:not(:last-child) {\n    border-bottom: 1px solid var(--secondary-border-color);\n  }\n\n  td:last-child {\n    padding-right: 32px;\n  }\n}\n\n@media (max-width: 768px) {\n  thead {\n    th:first-child {\n      padding-left: 16px;\n    }\n\n    th:last-child {\n      padding-right: 16px;\n    }\n  }\n\n  tbody {\n    td:first-child {\n      padding-left: 16px;\n    }\n\n    td:last-child {\n      padding-right: 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
